(function (global) {
  'use strict';

  var DISCLAIMER_VERSION = '2026-08-28-v1';
  var DISCLAIMER_TEXT = "I understand my selected package is below D-Dey's recommendation and is not represented as satisfying flag-state, USCG, MCA, class, insurer, commercial, or operating requirements. I authorize checkout and accept responsibility for compliance review.";

  function property(item, key) {
    return item && item.properties ? String(item.properties[key] || '') : '';
  }

  function parsePlan(value) {
    return String(value || '').split(';').filter(Boolean).map(function (entry) {
      var parts = entry.split('=');
      var rawQuantity = parts.slice(1).join('=');
      return {
        key: parts[0],
        quantity: Math.max(0, parseInt(rawQuantity, 10) || 0),
        custom: /!$/.test(rawQuantity)
      };
    }).filter(function (entry) { return entry.key && entry.quantity > 0; });
  }

  function planFromCart(cart, briefId) {
    var fromAttributes = cart.attributes && cart.attributes['D-Dey Recommendation Plan'];
    if (fromAttributes) return String(fromAttributes);
    var sourceLine = (cart.items || []).find(function (item) {
      return property(item, '_DDEY Advisor Brief') === briefId && property(item, '_DDEY Recommendation Plan');
    });
    return sourceLine ? property(sourceLine, '_DDEY Recommendation Plan') : '';
  }

  function assessCart(cart) {
    var attributes = cart.attributes || {};
    var advisorLines = (cart.items || []).filter(function (item) {
      return Boolean(property(item, '_DDEY Advisor Brief'));
    });
    var briefId = String(attributes['D-Dey Advisor Brief ID'] || (advisorLines[0] && property(advisorLines[0], '_DDEY Advisor Brief')) || '');
    if (!briefId) return { advisor: false, reduced: false, briefId: '', plan: '', current: '', reasons: [] };

    var planValue = planFromCart(cart, briefId);
    var plan = parsePlan(planValue);
    if (!plan.length) return { advisor: true, reduced: false, briefId: briefId, plan: '', current: '', reasons: [] };

    var quantities = {};
    advisorLines.forEach(function (item) {
      if (property(item, '_DDEY Advisor Brief') !== briefId) return;
      var lineKey = property(item, '_DDEY Advisor Line Key');
      if (!lineKey) return;
      quantities[lineKey] = (quantities[lineKey] || 0) + Number(item.quantity || 0);
    });

    var reasons = [];
    plan.forEach(function (entry) {
      var current = quantities[entry.key] || 0;
      if (current < entry.quantity) {
        reasons.push(entry.key + ' ' + current + '/' + entry.quantity + (entry.custom ? ' custom' : ''));
      }
    });

    var currentPlan = plan.map(function (entry) {
      return entry.key + '=' + (quantities[entry.key] || 0);
    }).join(';');
    return {
      advisor: true,
      reduced: reasons.length > 0,
      briefId: briefId,
      plan: planValue,
      current: currentPlan,
      reasons: reasons
    };
  }

  function fingerprint(value) {
    var source = String(value || '');
    if (global.crypto && global.crypto.subtle && global.TextEncoder) {
      return global.crypto.subtle.digest('SHA-256', new global.TextEncoder().encode(source)).then(function (buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('');
      });
    }
    var hash = 2166136261;
    for (var i = 0; i < source.length; i += 1) {
      hash ^= source.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return Promise.resolve('fnv1a-' + (hash >>> 0).toString(16).padStart(8, '0'));
  }

  var logic = { parsePlan: parsePlan, assessCart: assessCart };
  global.DdeyAdvisorCartGuardLogic = logic;
  if (typeof module !== 'undefined' && module.exports) module.exports = logic;

  if (!global.document || !global.fetch) return;
  var panel = global.document.getElementById('DdeyAdvisorCartDisclaimer');
  if (!panel) return;

  var checkbox = global.document.getElementById('DdeyAdvisorCartDisclaimerCheckbox');
  var message = global.document.getElementById('DdeyAdvisorCartDisclaimerMessage');
  var status = global.document.getElementById('DdeyAdvisorCartDisclaimerStatus');
  var cartForm = panel.closest('form');
  var latest = null;
  var syncing = false;
  var refreshTimer = null;

  function updateAttributes(attributes) {
    return global.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart acknowledgement could not be recorded.');
      return response.json();
    });
  }

  function acceleratedButtons(hidden) {
    Array.prototype.forEach.call(global.document.querySelectorAll('.additional-checkout-buttons'), function (node) {
      node.hidden = hidden;
      node.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    });
  }

  function checkoutButtonsDisabled(disabled) {
    Array.prototype.forEach.call(global.document.querySelectorAll('button[name="checkout"], input[name="checkout"]'), function (node) {
      node.disabled = disabled;
      node.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function render(cart, assessment, selectionFingerprint) {
    latest = {
      cart: cart,
      assessment: assessment,
      selectionFingerprint: selectionFingerprint
    };
    if (!assessment.advisor || !assessment.reduced) {
      panel.hidden = true;
      checkbox.checked = false;
      acceleratedButtons(false);
      checkoutButtonsDisabled(false);
      return;
    }

    var accepted = cart.attributes &&
      cart.attributes['D-Dey Disclaimer Accepted'] === 'Yes' &&
      cart.attributes['D-Dey Disclaimer Version'] === DISCLAIMER_VERSION &&
      cart.attributes['D-Dey Disclaimer Selection Fingerprint'] === selectionFingerprint;
    panel.hidden = false;
    checkbox.checked = Boolean(accepted);
    message.textContent = 'Your cart is below advisor brief ' + assessment.briefId + '. Complete the acknowledgement to continue to checkout.';
    status.textContent = accepted ? 'Acknowledgement recorded for the quantities currently in this cart.' : '';
    acceleratedButtons(!accepted);
    checkoutButtonsDisabled(!accepted);
  }

  function refresh() {
    if (syncing) return Promise.resolve();
    syncing = true;
    return global.fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart state could not be checked.');
        return response.json();
      })
      .then(function (cart) {
        var assessment = assessCart(cart);
        return fingerprint(assessment.briefId + '|' + assessment.current).then(function (selectionFingerprint) {
          var acceptedForCurrentSelection = cart.attributes &&
            cart.attributes['D-Dey Disclaimer Accepted'] === 'Yes' &&
            cart.attributes['D-Dey Disclaimer Version'] === DISCLAIMER_VERSION &&
            cart.attributes['D-Dey Disclaimer Selection Fingerprint'] === selectionFingerprint;
          if (assessment.advisor && !assessment.reduced && cart.attributes && cart.attributes['D-Dey Compliance Selection'] === 'Reduced configuration') {
            return updateAttributes({
              'D-Dey Compliance Selection': 'Advisor recommendation',
              'D-Dey Selected Plan': assessment.current,
              'D-Dey Selected Package Fingerprint': selectionFingerprint,
              'D-Dey Reduced/Omitted Items': '',
              'D-Dey Disclaimer Required': 'No',
              'D-Dey Disclaimer Accepted': 'Not required',
              'D-Dey Disclaimer Version': DISCLAIMER_VERSION,
              'D-Dey Disclaimer Accepted At': '',
              'D-Dey Disclaimer Selection Fingerprint': selectionFingerprint,
              'D-Dey Disclaimer Text': ''
            }).then(function (updatedCart) {
              render(updatedCart, assessCart(updatedCart), selectionFingerprint);
            });
          }
          if (assessment.reduced && !acceptedForCurrentSelection && cart.attributes && cart.attributes['D-Dey Disclaimer Accepted'] === 'Yes') {
            return updateAttributes({
              'D-Dey Compliance Selection': 'Reduced configuration',
              'D-Dey Selected Plan': assessment.current,
              'D-Dey Selected Package Fingerprint': selectionFingerprint,
              'D-Dey Disclaimer Required': 'Yes',
              'D-Dey Disclaimer Accepted': 'No',
              'D-Dey Disclaimer Version': DISCLAIMER_VERSION,
              'D-Dey Disclaimer Accepted At': '',
              'D-Dey Disclaimer Selection Fingerprint': '',
              'D-Dey Disclaimer Text': DISCLAIMER_TEXT
            }).then(function (updatedCart) {
              render(updatedCart, assessCart(updatedCart), selectionFingerprint);
            });
          }
          render(cart, assessment, selectionFingerprint);
        });
      })
      .catch(function (error) {
        panel.hidden = false;
        checkbox.checked = false;
        checkbox.disabled = true;
        message.textContent = 'The advisor record could not be verified for this cart.';
        status.textContent = error.message + ' Please refresh or contact D-Dey before checkout.';
        acceleratedButtons(true);
        checkoutButtonsDisabled(true);
      })
      .finally(function () { syncing = false; });
  }

  function scheduleRefresh() {
    global.clearTimeout(refreshTimer);
    refreshTimer = global.setTimeout(refresh, 850);
  }

  checkbox.addEventListener('change', function () {
    if (!latest || !latest.assessment.reduced) return;
    checkbox.disabled = true;
    status.textContent = checkbox.checked ? 'Recording acknowledgement…' : 'Removing acknowledgement…';
    var accepted = checkbox.checked;
    var acceptedAt = accepted ? new Date().toISOString() : '';
    updateAttributes({
      'D-Dey Compliance Selection': 'Reduced configuration',
      'D-Dey Selected Plan': latest.assessment.current,
      'D-Dey Selected Package Fingerprint': latest.selectionFingerprint,
      'D-Dey Disclaimer Required': 'Yes',
      'D-Dey Disclaimer Accepted': accepted ? 'Yes' : 'No',
      'D-Dey Disclaimer Version': DISCLAIMER_VERSION,
      'D-Dey Disclaimer Accepted At': acceptedAt,
      'D-Dey Disclaimer Selection Fingerprint': accepted ? latest.selectionFingerprint : '',
      'D-Dey Disclaimer Text': DISCLAIMER_TEXT
    }).then(function (cart) {
      render(cart, assessCart(cart), latest.selectionFingerprint);
    }).catch(function (error) {
      checkbox.checked = false;
      status.textContent = error.message + ' Please try again.';
      acceleratedButtons(true);
    }).finally(function () {
      checkbox.disabled = false;
    });
  });

  if (cartForm) {
    cartForm.addEventListener('submit', function (event) {
      var submitter = event.submitter || global.document.activeElement;
      var isCheckout = submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout';
      if (!isCheckout || !latest || !latest.assessment.reduced) return;
      var accepted = latest.cart.attributes &&
        latest.cart.attributes['D-Dey Disclaimer Accepted'] === 'Yes' &&
        latest.cart.attributes['D-Dey Disclaimer Version'] === DISCLAIMER_VERSION &&
        latest.cart.attributes['D-Dey Disclaimer Selection Fingerprint'] === latest.selectionFingerprint;
      if (accepted) return;
      event.preventDefault();
      panel.hidden = false;
      status.textContent = 'Check the acknowledgement before continuing to checkout.';
      checkbox.focus();
    });

    cartForm.addEventListener('change', function (event) {
      if (event.target && event.target.hasAttribute('data-quantity-input')) scheduleRefresh();
    });
    cartForm.addEventListener('click', function (event) {
      if (event.target && event.target.closest('[data-cart-remove]')) scheduleRefresh();
    });
  }

  checkoutButtonsDisabled(true);
  acceleratedButtons(true);
  refresh();
})(typeof window !== 'undefined' ? window : globalThis);
